import fetch from '@/service/fetch';

export function getMemFirst() {
  return fetch('/api/portal/mem/first');
}

export function getMemList(params) {
  return fetch('/api/portal/mem/page', {
    data: params
  });
}

export function getMemDetail(params) {
  return fetch(`/api/u-portal/mem/org/detail/${params.id}`);
}

export function validatePhone(params) {
  return fetch('/api/mem/register/judge-account', {
    data: params
  });
}

export function registerOrg(params) {
  return fetch('/api/mem/register/org', {
    method: 'POST',
    data: params
  })
}

export function registerPersonal(params) {
  return fetch('/api/mem/register/personal', {
    method: 'POST',
    data: params
  })
}

export function queryPersonalApprovalProgress(params) {
  return fetch('/api/mem/register/approval-progress', {
    data: { ...params, memType: 'personal' },
  });
}

export function queryApprovalProgress(params) {
  return fetch('/api/mem/register/approval-progress', {
    data: params,
  });
}

export function getDict() {
  return fetch('/api/common/dic/getDicsByTypes?businessTypes=mem_org_type,org_categary,mem_personal_political_status,certificate_type,mem_personal_highest_education')
}